import React, { FC } from 'react'
import styled from 'styled-components'

import { usePagination } from '@ucheba/utils/hooks/usePagination'
import { Text } from '@ucheba/ui/components/Text/desktop'

import { Pagination as PaginationComponent } from '@ucheba/ui/components/Pagination/desktop'

import { IPaginationProps } from '../types'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Pagination: FC<IPaginationProps> = (props) => {
  const { totalCount, total, showItemsCount, excludeQuery } = props

  const { currentPage, setCurrentPage, totalPages } = usePagination(
    total || 0,
    showItemsCount
  )

  return (
    <Container>
      <Text fontWeight='bold' textAlign='center'>
        {totalCount}
      </Text>

      <PaginationComponent
        excludeQuery={excludeQuery}
        totalPages={totalPages}
        currentPage={currentPage}
        changePageHandler={setCurrentPage}
      />
    </Container>
  )
}

export default Pagination
